const sizeConfigs = {
    sidebar: {
        width: '250px',
    },
    topbar: {
        height: '70px',
    }
}

export default sizeConfigs;